import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {getNoData, ttl2text} from "../../items/index.js";
import u from "../../../../util"
import Widget from "../widget.js";
import {addProjectListClickEvent} from "./event.js";
import {getProjectsHtmByRecord} from "./item.js";
import {addFilterEvent} from "../filter-popup/index.js";

const TYPE = [
    'RECENT',
    'ALL'
]

export class ProjectListWidget extends Widget {

    async setup(props) {
        return super.setup(props);
    }

    async getData() {
        const inputData = {
            ...this.$props.pageData,
            COLABO_FLD_KIND: "1",
            COLABO_FLD_SRNO: Number(this.$props.FIL_END_DT_GUBUN) === 2 ? '3' : '11',
            MODE: this.$props.FIL_END_DT_GUBUN ? TYPE[this.$props.FIL_END_DT_GUBUN - 1] : TYPE[0],
        }
        return await super.checkDataVersion(inputData)
    }

    async getDBData(inputData) {
        const data = await DashboardApi.getApi(this.$props.API_KEY, inputData)
        this.$props.pageData.NEXT_YN = u.n2v(data.NEXT_YN, "N");
        return {recordData: data[this.$props.RECORD]};
    }

    async render() {
        $(this.$target).empty();
        $(this.$target).drawListHelper({
            pageData: this.$props.pageData,
            nextYn: this.$props.pageData.NEXT_YN,
            records: this.$props.data,
            noDataHtml: getNoData(Number(this.$props.FIL_END_DT_GUBUN) === 2 ? 'favorite' : 'myPrj'),
            callback: {
                scroll: () => {
                    this.setup.bind(this)({
                        isDataDrivenRendering: true,
                        isScrolling : true,
                    })
                },
                item: getProjectsHtmByRecord,
                final: this.mounted.bind(this)
            }
        })
    }

    mounted() {
        super.mounted();

        const $t = $(this.$target);
        if ($t.find('.js-new-prj').length === 0
            && this.$props.data.length > 0) {
            $t.prepend(`<li class="js-new-prj widget-default">
                            <span class="prj-icon-box"></span>
                            <span class="prj-title">${i18next.t(common.createProject)}</span>
                        </li>`)
        }
        $t.find('.widget-article-list').removeClass('dash-pending')
        $t.find('.dash-num-pending').remove()
    }

    setEvent() {
        const $w = $(this.$target).closest('.widget-my-prj');
        addFilterEvent.bind(this)({$w, filterGb: "my_prj_filter"})
        $w.off('click').on('click', (e) => addProjectListClickEvent(e, this));
    }

}
